<template>
  <div>
    <launcher
      :class="companyStyle"
      :is-channel-enabled="isChannelEnabled"
      :is-embedded="isEmbedded"
      :participants="participants"
      :title="title"
      :subtitle="subtitle"
      :welcome-form-logo="welcomeFormLogo"
      :title-image-url="titleImageUrl"
      :on-message-was-sent="onMessageWasSent"
      :message-list="messageList"
      :new-messages-count="newMessagesCount"
      :chat-status="chatStatus"
      :close="closeChat"
      :open="openChat"
      :show-emoji="showEmoji"
      :show-file="showFile"
      :show-information="showInformation"
      :show-typing-indicator="showTypingIndicator"
      :colors="colors"
      :always-scroll-to-bottom="alwaysScrollToBottom"
      :placeholder="placeholder"
      :plugin-enabled-microphone="pluginEnabledMicrophone"
      :current-form="currentForm"
      :voice-on="voiceOn"
      :avatar="avatar"
      :show-input="showInput"
      :css-style="cssStyle"
      :last-user-text="lastUserText"
      :enabled-close-btn="enabledCloseBtn"
      :company-name="companyStyle"
      :display-vertical-launcher="displayVerticalLauncher"
      :show-aigenerative-info="showAigenerativeInfo"
    />
    <modal
      style="z-index: 999999"
      name="chat-modal"
      :width="modalWidth"
      :height="modalHeight"
    >
      <div v-html="sanitizedRawModalHtml" />
    </modal>
    <modal
      style="z-index: 999999"
      name="img-modal"
      :width="modalWidthImg"
      :height="modalHeightImg"
      :max-width="productModalMaxWidth"
      :max-height="productModalMaxHeight"
      :styles="modalStyles"
      centered
    >
      <div v-html="sanitizedRawModalHtml" />
    </modal>
    <modal
      style="z-index: 999999"
      name="chatbot-close-modal"
      :width="closeChatbotModalWidth"
      :height="closeChatbotModalHeight"
    >
      <modal-close-chatbot :company="companyStyle" />
    </modal>
    <modal
      style="z-index: 999999"
      name="hubspot-modal"
      :width="hubspotModalWidth"
      :height="hubspotModalHeight"
      :max-width="hubspotModalMaxWidth"
      :max-height="hubspotModalMaxHeight"
      :scrollable="true"
      :adaptive="true"
      :click-to-close="false"
      :styles="hubspotModalStyle"
    >
      <hubspot-modal-body
        :url="hubspotCalendarUrl"
        :user-data="userData"
      />
    </modal>
  </div>
</template>

<script>
import { serverUI } from './main'
import launcher from './Launcher.vue'
import Protocol from './protocol.js'
import { setTimeout } from 'timers'
import hubspotModalBody from './components/hubspot/hubspotModalBody.vue'
import { getCSS, getForms } from './companySetup.js'
import ModalCloseChatbot from './components/otros/modalCloseChatbot.vue'
import DOMPurify from 'dompurify'
export default {
  name: 'App',
  components: {
    launcher,
    hubspotModalBody,
    ModalCloseChatbot
  },
  data () {
    return {
      sentecePool: ['Cuéntame...', 'Cuéntame...', 'Cuéntame...', 'Cuéntame...'],

      avatar: {},
      isEmbedded: false,
      isChannelEnabled: false,
      participants: [],
      titleImageUrl: '',
      messageList: [],
      newMessagesCount: 0,
      chatStatus: 'new',
      showEmoji: false,
      showFile: false,
      showInformation: false,
      showAigenerativeInfo: false,
      showTypingIndicator: '',
      colors: {},
      alwaysScrollToBottom: true,
      title: '',
      subtitle: '',
      welcomeFormLogo: '',
      placeholder: '',
      pluginEnabledMicrophone: false,
      currentForm: '',
      voiceOn: true,
      rawModalHtml: '',
      modalWidth: '75%',
      modalHeight: '75%',
      showInput: '',
      cssStyle: {},
      lastUserText: '',
      customAvatarAssistants: [],
      defaultAvatar: {},
      customPlaceholders: [],
      modalWidthImg: '85%',
      modalHeightImg: 'auto',
      productModalMaxWidth: 600,
      productModalMaxHeight: 700,

      hubspotModalWidth: '90%',
      hubspotModalHeight: '75%',
      hubspotModalMaxWidth: 700,
      hubspotModalMaxHeight: 600,
      hubspotModalStyle: 'border-radius: 15px;',
      hubspotCalendarUrl: '',
      hubspotCalendarModalActive: false,
      userData: {},
      companyStyle: '',
      defaultForms: [],

      closeChatbotModalWidth: '85%',
      closeChatbotModalHeight: '30%',

      modalStyles: {
        'background-color': 'transparent',
        'box-shadow': 'none'
      },
      enabledCloseBtn: false,
      displayVerticalLauncher: false
    }
  },
  computed: {
    sanitizedRawModalHtml () {
      return DOMPurify.sanitize(this.rawModalHtml)
    }
  },
  created () {
    /* Borra avatar existente */
    localStorage.removeItem('avatar')

    // Defaults
    this.title = this.avatar.name
    this.subtitle = this.avatar.position
    this.welcomeFormLogo = this.avatar.welcome_form_logo
    this.titleImageUrl = ''

    this.showInput = 'flex'
    this.participants = [
      {
        id: 'IA',
        name: 'IA',
        imageUrl: ''
      }
    ]
    this.colors = {
      header: {
        bg: '#326295',
        text: '#fff'
      },
      launcher: {
        bg: '#326295'
      },
      messageList: {
        bg: '#fff'
      },
      sentMessage: {
        bg: '#a7bcd6',
        text: '#222222'
      },
      receivedMessage: {
        bg: 'white',
        text: '#3f3f3f'
      },
      userInput: {
        bg: '#fff',
        text: '#212121'
      }
    }
    this.showFile = false
    // Comunicacion
    this.protocol = new Protocol(this, window.GB_SETUP)
    this.protocol.onStart()
    this.showInformation = this.protocol.enabled_info
    this.showAigenerativeInfo = this.protocol.ai_generative_enabled

    this.companyCSS = getCSS(window.GB_SETUP.style)

    this.companyStyle = this.companyCSS.name

    this.companyForms = getForms(this.companyStyle)
    this.defaultForms = ['Login', 'Score', 'ScoreConversation', 'ContactForm', 'CotizacionForm', 'DiasLibresForm', 'NegativeFeedbackForm']

    this.cssStyle = this.companyCSS.style

    this.avatar = this.companyCSS.avatar
    this.defaultAvatar = this.companyCSS.avatar

    this.enabledCloseBtn = this.protocol.enabledCloseBtn

    if (this.companyStyle === 'gatblac-new') {
      try {
        const eyes = document.getElementsByClassName('follow-eyes')
        document.onmousemove = function (event) {
          const x = (event.clientX * 5) / window.innerWidth + '%'
          const y = (event.clientY * 5) / window.innerHeight + '%'
          for (const eye of eyes) {
            eye.style.left = x
            eye.style.top = y
            eye.style.transform = `translate(${x},${y})`
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
    serverUI.$on('FormEvent', e => {
      // console.log("PROTOCOL", e);
      if (!e._loop) {
        this.protocol.formEvent(e)
      }
    })

    serverUI.$on('setLastUserText', lastUserText => {
      if (lastUserText) {
        this.lastUserText = lastUserText
      } else this.lastUserText = ''
    })

    serverUI.$on('useDefaultAvatar', imgError => {
      if (imgError) {
        this.title = this.defaultAvatar.name
        this.subtitle = this.defaultAvatar.position
        this.welcomeFormLogo = this.defaultAvatar.welcome_form_logo
        this.avatar = this.defaultAvatar
      }
    })
    serverUI.$on('updateModalImg', url => {
      this.showModalImg(url)
    })
    serverUI.$on('closeHubspotCalendarModal', () => {
      this.hideHubspotCalendarModal()
    })
    serverUI.$on('hideChatbot', () => {
      this.showModalCloseChatbot()
    })
    serverUI.$on('modalHideChatbot', () => {
      this.hideModalCloseChatbot()
    })
    serverUI.$on('modalCloseChatbot', () => {
      this.eventCloseChatbot()
      this.displayVerticalLauncher = true
    })
  },
  updated () {
    this.protocol.checkChatbotOff()
  },
  methods: {
    showModal (html, props) {
      this.rawModalHtml = html
      this.modalWidth = props && props.width ? props.width : '50%'
      this.modalHeight = props && props.height ? props.height : '50%'
      this.$modal.show('chat-modal')
    },
    hideModal () {
      this.$modal.hide('chat-modal')
    },
    showModalImg (imgUrl) {
      const img = new Image()
      let styleAdd = 'width: 85%;'
      img.src = imgUrl
      const tagImg = `<img src="${img.src}" style="width: 100%">`
      // if (img.width > 576) {
      //   // tagImg = `<img src="${img.src}" style="width: 100%">`
      //   styleAdd = 'width: auto; max-width: 100%;'
      // }
      if (img.height > 700) {
        styleAdd = 'width: 50%;'
      } else if (img.height > 850) {
        styleAdd = 'width: 45%;'
      }
      this.rawModalHtml = ` <div class="contenedor-modal" style="position: relative; ${styleAdd} margin: auto;">
                            <div style="width: 16px;  position: absolute;  padding: 10px;  float: right;  z-index: 2;  cursor: pointer;  right: 5px;" onclick="window.protocol.view.hideModalImg()">
                              <img style="position: relative; width: 20px;" src="https://biceqa.gatblac.com/static/multimedia/iconos/botones/close.png">
                            </div>
                            <div style="height: auto; text-align: center; padding: 35px 5px 35px 5px; max-width: 100%; width: auto;">
                              ${tagImg}
                            </div>
                            </div>
                            <style> .contenedor-modal { position:relative; margin:auto; }
                            @media (max-width: 576px) {
                              .contenedor-modal {
                                width: 100%;
                              }
                            }</style>`
      this.$modal.show('img-modal')
    },
    hideModalImg () {
      this.$modal.hide('img-modal')
    },
    showModalCloseChatbot () {
      this.$modal.show('chatbot-close-modal')
    },
    hideModalCloseChatbot () {
      this.$modal.hide('chatbot-close-modal')
    },
    eventCloseChatbot () {
      this.protocol.hideChatbot()
      this.$modal.hide('chatbot-close-modal')
    },
    addChatSystem (ts, text) {
      this.messageList.push({
        type: 'system',
        data: { text: text || '', meta: ts }
      })
    },
    addChatMe (ts, text, _id) {
      if (text && text.length > 0) {
        this.messageList.push({
          _id: _id,
          author: 'me',
          type: 'text',
          data: { text, meta: ts }
        })
      }
    },
    // configure bot de facebook
    addChat (ts, text, voice, _id = 0, feedback) {
      if (text && text.length > 0) {
        this.messageList.push({
          _id: _id,
          author: this.participants[0].id,
          type: 'text',
          data: { text, voice, meta: ts },
          notFeedback: feedback || false
        })
      }
    },
    deleteChat () {
      this.newMessagesCount = 0
      this.messageList = []
    },
    setEmbedded (on) {
      this.isEmbedded = on
    },
    showCloseButton () {
      const closeBtn = document.getElementById('closeBtnItem')
      if (closeBtn) closeBtn.style.display = ''
    },
    hideCloseButton () {
      const closeBtn = document.getElementById('closeBtnItem')
      if (closeBtn) closeBtn.style.display = 'none'
    },
    recieveMessage (type, ts, text, commin = 0) {
      const { chatId, voice, notFeedback, score, endFeedback } = commin
      if (text && text.length > 0) {
        this.newMessagesCount =
          this.chatStatus === 'active'
            ? this.newMessagesCount
            : this.newMessagesCount + 1
        this.messageList.push({
          _id: chatId || 0,
          author: commin.name || name,
          type: type,
          score: score,
          data: { text, voice, meta: ts },
          notFeedback: notFeedback,
          endFeedback: endFeedback
        })
      }
      /* Reproduce voice si esta activado */
      if (voice && this.voiceOn) {
        const voice_audio = new Audio()
        voice_audio.src = voice
        voice_audio.type = 'audio/wav'
        voice_audio.autoplay = false
      }
    },
    onMessageWasSent (message) {
      // bypass a protocolo
      if (message.type === 'text') {
        this.protocol.eventMsgTx(message.data.text)
      } else {
        this.messageList.push(message)
      }
    },
    messageWaiting (show) {
      this.showTypingIndicator = show ? this.participants[0].id : ''
    },
    openChat () {
      this.protocol.showChatbot()
      this.chatStatus = 'active'
      this.newMessagesCount = 0
      this.setInputText(true)
      this.protocol.eventchatOpened()
    },
    openChatMinimize () {
      this.chatStatus = 'minimize'
      this.newMessagesCount = 0
    },
    closeChat (e, force = false) {
      this.chatStatus = this.protocol.eventchatClosed(e, force)
      if (this.displayVerticalLauncher) this.eventCloseChatbot()
    },
    getCurrentForm () {
      return this.currentForm
    },
    setCurrentForm (form, formData) {
      const defaultForm = this.defaultForms.find(f => f === form)
      this.currentForm = defaultForm == null ? '' : defaultForm
      if (formData) this.setFormNewData(defaultForm, 'init', formData)
      if (this.companyForms.forms.length >= 1) {
        const companyForm = this.companyForms.forms.find(f => f.name === form)
        if (companyForm) {
          this.currentForm = companyForm.name == null ? '' : companyForm.name
          if (formData) this.setFormNewData(companyForm.name, 'init', formData)
        }
      }
    },
    setFormNewData (form, evento, obj) {
      setTimeout(() => {
        serverUI.$emit('FormEvent', {
          _loop: true,
          form,
          evento,
          dato: obj
        })
      }, 100)
    },
    setInputText (state) {
      if (state) {
        this.showInput = 'auto'
        if (this.customPlaceholders && this.customPlaceholders.length > 0) this.placeholder = this.customPlaceholders[Math.floor(Math.random() * this.customPlaceholders.length)]
        else this.placeholder = this.sentecePool[Math.floor(Math.random() * this.sentecePool.length)]
      } else {
        this.showInput = 'none'
        this.placeholder = 'Por favor espera..'
      }
      return this.showInput
    },
    setCustomAvatarAssistans (avatars) {
      this.customAvatarAssistants = avatars
      /* this.customAvatarAssistants.push(this.defaultAvatar) */
      localStorage.removeItem('avatar')
      const index = this.customAvatarAssistants.length === 1 ? 0 : Math.floor(Math.random() * this.customAvatarAssistants.length)
      this.avatar = this.customAvatarAssistants[index]
      this.title = this.customAvatarAssistants[index].name
      this.subtitle = this.customAvatarAssistants[index].position
      this.welcomeFormLogo = this.customAvatarAssistants[index].welcome_form_logo
      localStorage.setItem('avatar', JSON.stringify(this.avatar))
    },
    setCustomPlaceholders (placeholders) {
      this.customPlaceholders = placeholders
    },
    setEnabledMicrophone (enabledMicrophone) {
      this.pluginEnabledMicrophone = enabledMicrophone
    },
    refreshAvatar () {
      localStorage.removeItem('avatar')
    },
    showHubspotCalendarModal (userData) {
      this.hubspotCalendarUrl = userData.urlCalendar
      this.userData = userData
      this.hubspotCalendarModalActive = true
      this.$modal.show('hubspot-modal')
    },
    hideHubspotCalendarModal () {
      this.hubspotCalendarModalActive = false
      this.$modal.hide('hubspot-modal')
    },
    setDisplayVerticalLauncher (state) {
      this.displayVerticalLauncher = state
    }
  }
}
</script>

<style lang="scss">
.tooltip-gb {z-index: 100000 !important; }

</style>
